export function reverseArray<T>(array: T[]): T[] {
  const newArray = [];

  for (let i = array.length - 1; i >= 0; i -= 1) {
    newArray.push(array[i]);
  }

  return newArray;
}
